import React from 'react';
import './compact-breadcrumb.css';

export default function CompactBreadcrumb({ parent, current, onNavigate, disabled = false, items }) {
  const ancestors = items || [{ label: parent, onNavigate }];
  return <nav className="compact-breadcrumb" aria-label="Breadcrumb">
    {ancestors.map((item, index) => <React.Fragment key={`${item.label}-${index}`}>
      <button type="button" role="link" disabled={disabled} onClick={item.onNavigate}>{item.label}</button>
      <span aria-hidden="true">/</span>
    </React.Fragment>)}
    <span aria-current="page">{current}</span>
  </nav>;
}
